import { render, staticRenderFns } from "./__TemBichCS.vue?vue&type=template&id=6f7a37bb&"
import script from "./__TemBichCS.vue?vue&type=script&lang=js&"
export * from "./__TemBichCS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports